import { connect } from 'react-redux';
import InsuranceLink from './InsuranceLink';
import { fetchData } from './actions';
import { getFilteredInsuranceContracts, getFilteredInsuredDevices, getUser, getFilteredPurchase } from 'reducers';

const mapStateToProps = (state, { sprintSubId: subscription, bypassedSubId: bypassedSubscription, quickSubId: quickSubscription }) => {
  const user = getUser(state)
  const contracts =  getFilteredInsuranceContracts(state, { subscription, bypassedSubscription, quickSubscription });
  const pendingContract = contracts.find( contract => contract.status === 'pending');

  const devices = pendingContract ? getFilteredInsuredDevices(state, pendingContract.id) : undefined;
  const activeDevice = devices ? devices.find(device => device.status === 'active') : undefined;
  const purchases = activeDevice ? getFilteredPurchase(state, activeDevice.activation_lineitem) : undefined;

  return {
    user,
    contracts,
    devices,
    purchases,
  }
};

const mapDispatchToProps = {
  fetchData,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsuranceLink);
